import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Modal, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { CloseCircleOutline, DocumentTextOutline, DownloadOutline, WalletOutline, CardOutline } from 'react-ionicons';
import MainLayout from '../../layouts/MainLayout';
import { connect } from 'react-redux';
import Overlay from '../../components/Overlay/Overlay';
import languageManager, { T } from '../../helpers/Language';
import { toShortDate, toShortNumDate } from '../../helpers/Date';
import { toCurrencyUSD } from '../../helpers/Number';
import Cards from 'react-credit-cards-2';
import Badge from 'react-bootstrap/Badge';
import { User as BillingAPI } from '../../api';
import { InformationCircleOutline } from 'react-ionicons/lib/';

import './Billing.scss';
import store from '../../helpers/Store';

import PaymentWarning from './Payments/PaymentWarning';
import Stripe from './SavedCard/Stripes';
import ChoosePaymentMethod from './Payments/ChoosePayment';
import ReactGA from 'react-ga4';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';

import API, { toHardLink } from '../../api/app.api';
import * as DriveAPI from '../../api/actions/Drive';
export const Drive = DriveAPI;

export const downloadFile = (fileId) => {
    return toHardLink(`/api/v1/module/billing/file/${fileId}/download`);
}

const TransactionTable = ({
    invoices,
    onClickSelectT,
    onClickOpenHistory
}) => {

    let trElements = (
        <Card style={{ height: '100px' }} className={`invoices-container`}>
            <span className="m-auto">No transaction found</span>
        </Card>
    );
    if (Array.isArray(invoices) && invoices.length) {
        trElements = invoices.map((tr) => (
            <Row md={12} key={`${tr.ID}-3`} >
                <Card className={`invoices-container ${tr.selected ? 'selected' : ''} ${tr.BalanceDue === 0 ? 'paid' : ''}`} style={{ 'marginBottom': '10px', 'overflow': '' }}>
                    <Col>
                        <Row className='invoice-item-container'>
                            <Col>
                                <Row style={{ height: '100%' }}>
                                    <Col className='invoices-title-item center no-border-left'>
                                        <DocumentTextOutline
                                            height="35px"
                                            width="35px"
                                        />
                                        {' '}
                                        <Badge bg="primary">Invoice  #{tr.ID}</Badge>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className='invoices-title-item center'>
                                <span className='subTitle'>
                                    Invoice Amount
                                </span>
                                {toCurrencyUSD(tr.Total)}
                            </Col>
                            <Col className='invoices-title-item center important'>
                                <span className='subTitle'>
                                    Remaining due
                                </span>
                                {toCurrencyUSD(Number(tr.BalanceDue))}
                            </Col>
                            <Col className='invoices-title-item center'>
                                <span className='subTitle'>
                                    Invoice Date
                                </span>
                                {toShortNumDate((new Date(tr.InvoiceDate)).toJSON())}
                            </Col>
                            <Col onClick={() => onClickOpenHistory(tr.ID)} className='invoices-title-item center underlined cursor-pointer'>
                                <span className='subTitle'>
                                    Payments history
                                </span>
                                <span>{tr && tr.Transactions.length > 0 ? (tr.opened ? 'Hide' : 'Show') : 'none'} ({tr.Transactions.length})</span>
                            </Col>
                            <Col>
                                <Row style={{ height: '100%' }}>
                                    <Col md={12} className='invoices-title-item center cursor-pointer download'>
                                        <span className='subTitle'>
                                            Invoice PDF
                                        </span>
                                        {
                                            !tr.DriveFileID ? "No Invoice Available" :
                                                <DownloadOutline
                                                    title="Download PDF Invoice"
                                                    height="35px"
                                                    width="35px"
                                                    onClick={() => window.open(
                                                        downloadFile(tr.DriveFileID) + '&download=1',
                                                        '_blank' // <- This is what makes it open in a new window.
                                                    )}
                                                />
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Row style={{ height: '100%' }}>
                                    <Col className='invoices-title-item center no-border-right'>
                                        {
                                            tr.TermsCode != 'CC' && tr.TermsCode != 'DUR' && tr.TermsCode != 'NET30' ?
                                            <Button disabled={true} style={{ 'width': '90%' }}>Unavailable</Button>
                                                :
                                                tr.selected ?
                                                    <Button variant="warning" onClick={() => onClickSelectT(tr.ID)} style={{ 'width': '90%' }}>Unselect</Button> :
                                                    <Button disabled={tr.BalanceDue === 0 ? true : false} onClick={() => onClickSelectT(tr.ID)} style={{ 'width': '90%' }}>{tr.BalanceDue === 0 ? 'Fully Paid' : "Select"}</Button>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Card>
                {
                    <div style={{ 'marginTop' : '-5px', 'marginBottom' : '5px' }}>
                        {
                            tr && tr.Transactions.length > 0 &&
                            tr.Transactions.map(tr2 =>
                                <Row>
                                    <Col md={2}></Col>
                                    <Col style={{'padding' : 0}}>
                                        <Card key={tr2.validatedat} className={`expand-payment-block ${tr.opened ? 'expanded' : ''}`}>
                                            <Row className='expand-centered-block payment-block'>
                                                <Col md={4} className='payment-block-col'>
                                                    <WalletOutline
                                                        height="35px"
                                                        width="35px"
                                                    />
                                                    {' '}
                                                    <Badge style={{ marginLeft: '5px' }} bg="success">Payment</Badge>
                                                </Col>
                                                <Col md={2} className='payment-block-col'>
                                                    {
                                                        tr2.validatedat ? toShortNumDate((new Date(tr2.validatedat)).toJSON()) : ''
                                                    }
                                                </Col>
                                                <Col md={2} className='payment-block-col cursor-pointer downloadSVG DownloadLink'>
                                                {
                                                    !tr2.receipt_url ? "" : <ModalReceipt receiptURL={tr2.receipt_url}/>
                                                }
                                                </Col>
                                                <Col md={2} className='payment-block-col'>
                                                    <Badge bg={`${tr2.status === "SUCCESS" ? "success" : "warning"}`}>{tr2.status}</Badge>
                                                </Col>
                                                <Col md={2} className='payment-block-col currency'>
                                                    {toCurrencyUSD(Number(tr2.amount / 100))}
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            )
                        }
                    </div>
                }
            </Row>
        ));
    }
    return (
        <Row>
            <Col sm={12} style={{ 'marginTop': '5px', 'overflow': '' }}>
                <Row className='invoices-list-container'>
                    {trElements}
                </Row>
            </Col >
        </Row >
    )
}

const ModalReceipt = ({receiptURL}) => {
    return (<div>
        <DownloadOutline
            title="Show Transaction Receipt"
            height="35px"
            width="35px"
            onClick={() => window.open(
                receiptURL,
                '_blank' // <- This is what makes it open in a new window.
            )}
        />
        <span style={{'fontWeight' : 600}} onClick={() => window.open(
                receiptURL,
                '_blank' // <- This is what makes it open in a new window.
            )}>Receipt</span>
    </div>)
}

const ModalCC = ({ cardsModalVisibility, setCardsModalVisibility, paymentsList, userProfile, getPaymentMethod }) => {
    const [newCardVisibility, setnewCardVisibility] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [intent, setIntent] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);

    async function onCloseModal() {
        if (newCardVisibility)
        {
            setIsLoading(true);
            await BillingAPI.deletePaymentIntent(intent);
            setIsLoading(false);
        }
        setnewCardVisibility(false);
        setCardsModalVisibility(false);
        setIntent(null);
        setClientSecret(null);
        ReactGA.event({
            category: 'Billing',
            action: `Close Model Credit Cards`,
        });
    }

    async function onReturnToList()
    {
        if (newCardVisibility)
        {
            setIsLoading(true);
            await BillingAPI.deletePaymentIntent(intent);
            setnewCardVisibility(false);
            setIsLoading(false);
        }          
    }

    async function onCreateNewCard() {
        setIsLoading(true);
        const pm = await BillingAPI.newPaymentMethod(userProfile);
        setIntent(pm.setupIntent);
        setClientSecret(pm.setupIntent?.client_secret)
        setnewCardVisibility(true);
        setIsLoading(false);
    }

    async function onSuccessNewCard() {
        setIsLoading(true);
        await getPaymentMethod();
        setnewCardVisibility(false);
        ReactGA.event({
            category: 'Billing',
            action: 'New Card Success',
        });
        setIsLoading(false);
    }

    async function removePaymentMethod(data) {
        setIsLoading(true);
        await BillingAPI.deletePaymentMethod(data);
        ReactGA.event({
            category: 'Billing',
            action: 'Delete Card',
        });
        await getPaymentMethod();
        setIsLoading(false);
    }

    async function refreshPaymentMethods()
    {
        setIsLoading(true);
        await getPaymentMethod();
        setIsLoading(false);
    }

    useEffect(() => {        
        if (!newCardVisibility) // Credit Card list is shown
        {
            refreshPaymentMethods();
        }        
    }, [newCardVisibility]);

    return (
        <Modal show={cardsModalVisibility} onExited={() => { }}>
            {isLoading ? <Overlay show /> : null}
            <Modal.Header>
                <Modal.Title style={{ width: '100%' }}>
                    <Row>
                        <Col md={8}>
                            Credit card list
                        </Col>
                        <Col md={4}>
                            {
                                !newCardVisibility ?
                                    <Button variant="primary" onClick={() => onCreateNewCard()} className="w-100">
                                        Add New
                                    </Button>
                                    :
                                <Button variant="primary" onClick={() => onReturnToList()} className="w-100">
                                    Return
                                </Button>
                            }
                        </Col>
                    </Row>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <div className={`card2 ${newCardVisibility ? 'flipped' : ''}`}>
                        <div className="card__face">
                            {
                                paymentsList && paymentsList.map(item => {
                                    const names = item.name?.split('-');
                                    const num = names ? names[1] : '';
                                    const name = names ? names[0] : '';
                                    return (
                                        <Col key={item.id} sm={12} style={{ 'marginTop': '10px' }}>
                                            <div className='cc-block'>
                                                <Cards
                                                    issuer={name}
                                                    cvc={'123'}
                                                    expiry={item.expiresAt}
                                                    name={`${userProfile.firstname} ${userProfile.lastname}`}
                                                    number={`**** **** **** ${num}`}
                                                    preview={true}
                                                />                                                
                                            </div>
                                            <div className="cc-description-block">
                                                <div className="cc-title">{userProfile.firstname} {userProfile.lastname} - {name.substring(name.length - 5, name.length).toUpperCase()}</div>
                                                <div className="cc-description">Credit card ending in •••• {num}</div>
                                                <div className="cc-action" onClick={() => removePaymentMethod(item)}>Remove</div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                            {
                                !paymentsList || paymentsList.length === 0 &&
                                <Col md={12} className='empty-card' style={{ 'marginTop': '10px' }}>
                                    <div>
                                        Nothing to show
                                    </div>
                                </Col>
                            }
                        </div>
                        <div className="card__face card__face--back">
                            <Row>
                                <Col md={12} style={{ 'marginTop': '10px' }}>
                                    {clientSecret && <Stripe successCB={onSuccessNewCard} loadingCB={(value) => setIsLoading(value)} clientSecret={clientSecret} />}
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Row>

            </Modal.Body>
            <Modal.Footer>
                <Row style={{ width: '100%' }}>
                    <Col xs={12} className="text-left">
                        <Button variant="secondary" style={{ width: '100%' }} onClick={onCloseModal}>{languageManager.T('GEN_CLOSE')}</Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}

const ModalPayment = ({ paymentsModalVisibility, setPaymentsModalVisibility, invoices, reload, paymentsList }) => {

    const [StripePaymentKey, setStripePaymentKey] = useState('');
    const [checkout, setCheckout] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [stripeError, setStripeError] = useState(null);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    function onCloseModal() {
        setPaymentsModalVisibility(false);
        setIsLoading(false);
        setCheckout(false);
        setIsComplete(false);
        setStripeError(null);
        setStripePaymentKey('');
        ReactGA.event({
            category: 'Billing',
            action: 'Close Payment Modal',
        });
        reload();
    }

    async function onPay() {
        setIsLoading(true);
        let data = [];
        ReactGA.event({
            category: 'Billing',
            action: 'Pay Invoice',
            label: `Number of incoices ${invoices.length}`
        });
        for (let index = 0; index < invoices.length; index++) {
            const invoice = invoices[index];
            data.push({
                "type": invoice.type || 'practice',
                "practiceId": invoice.ID,
                "amount": invoice.payAmount
            });
        }
        try {
            const pm = await BillingAPI.createPayment(data);
            setStripePaymentKey(pm.clientSecret);
            setCheckout(true);
        } catch (error) {
            console.log(error);
        }
        setIsLoading(false);
        return
    }

    async function onLoadingPayment(bValue) {
        setIsLoading(bValue);
    }

    async function onSuccessPayment() {
        setIsLoading(false);
        ReactGA.event({
            category: 'Billing',
            action: 'Success Payment',
        });
        setIsComplete(true);
    }

    async function onFailPayment(stripeError) {
        let message = "Unknown error.";
        let code = "invalid_stripe_error_code";
        let error;
        if (stripeError) {
            message = (stripeError.message ? stripeError.message : message);
            code = (stripeError.code ? stripeError.code : code);
        }
        error = {
            message: message,
            code: code
        };
        ReactGA.event({
            category: 'Billing',
            action: 'Fail Payment',
            label: `Fail Payment ${JSON.stringify(error)}`
        });
        setStripeError(error);
    }

    function onChangeInput(e, invoice) {
        invoice.payAmount = e.target.value;
        forceUpdate()
    }

    let trElements = (
        <Row>
            <Col style={{ height: '150px' }} className="text-center">No transaction found</Col>
        </Row>
    );

    let paymentInvoices = [...invoices.filter(i => i.selected === true)]
    for (let index = 0; index < paymentInvoices.length; index++) {
        const element = paymentInvoices[index];
        if (!element.payAmount) {
            element.payAmount = element.BalanceDue
        }
    }

    const balance = paymentInvoices?.reduce((balance, elm) => {
        return balance + Number(elm.payAmount || 0);
    }, 0);

    if (Array.isArray(paymentInvoices) && paymentInvoices.length) {
        trElements = paymentInvoices.map((tr) => (
            <Col key={`${tr.ID}-1`} md={12} className='payment-table'>
                <Row>
                    <Col md={1} className='element'>
                        <DocumentTextOutline
                            height="35px"
                            width="35px"
                            className="icon"
                        />                        
                    </Col>
                    <Col md={2} className='element'>
                        {tr.ID}
                    </Col>
                    <Col md={3} className='element'>
                        {Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(tr.InvoiceDate))}
                    </Col>
                    <Col md={3} className='element'>
                        {toCurrencyUSD(Number(tr.BalanceDue))}
                        <PaymentWarning transactions={tr.Transactions} />
                    </Col>
                    <Col md={3} className='element'>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Amount"
                                onChange={(e) => onChangeInput(e, tr)} 
                                value={tr.payAmount}
                            />
                        </FormControl>
                    </Col>
                </Row>
            </Col>
        ))
    }

    return (
        <Modal show={paymentsModalVisibility} onExited={() => { }} dialogClassName="PaymentModal">
            {isLoading ? <Overlay show /> : null}
            <Modal.Header>
                <Modal.Title style={{ width: '100%' }}>
                    <Row>
                        <Col md={12}>
                            Payment
                        </Col>
                    </Row>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    isComplete ?
                        <>
                            <div>Payment completed successfully.</div>
                        </> :
                        stripeError ?
                            <>
                                <div>An error occured. If the error persist contact your administrator.<br />
                                    Message: {stripeError.message} <br />
                                    Code: {stripeError.code}
                                </div>
                            </> :
                            !checkout ?
                                <>
                                    <Row style={{ borderBottom: '1px solid grey', marginBottom: '20px' }}>
                                        <Col md={12}>
                                            <Row>
                                                <Col md={1} className='TableTitle'>
                                                    PDF
                                                </Col>
                                                <Col md={2} className='TableTitle'>
                                                    Invoice ID
                                                </Col>
                                                <Col md={3} className='TableTitle'>
                                                    Invoice Date
                                                </Col>
                                                <Col md={3} className='TableTitle'>
                                                    Amount Due
                                                </Col>
                                                <Col md={3} className='TableTitle'>
                                                    Value
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {trElements}
                                    </Row>
                                    <Row className="mt-4">
                                        <Col style={{ fontWeight: 'bold' }} className="text-right mt-2" md={6}>
                                            Balance:
                                        </Col>
                                        <Col style={{ fontWeight: 'bold' }} className="text-right mt-2" md={6}>
                                            ${balance}
                                        </Col>
                                    </Row>
                                </> :
                                <>
                                    <Row style={{ borderBottom: '1px solid grey', marginBottom: '20px' }}>
                                        <Col md={12}>
                                            <Row>
                                                <Col md={4} className='TableTitle'>
                                                    PDF
                                                </Col>
                                                <Col md={4} className='TableTitle'>
                                                    Invoice ID
                                                </Col>
                                                <Col md={4} className='TableTitle'>
                                                    Value
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {trElements = paymentInvoices.map((tr) => (
                                            <Col key={`${tr.ID}-2`} md={12} className='payment-table'>
                                                <Row>
                                                    <Col md={4} className='element center no-border-left'>
                                                        <DocumentTextOutline
                                                            height="35px"
                                                            width="35px"
                                                        />
                                                    </Col>
                                                    <Col md={4} className='element'>
                                                        {tr.ID}
                                                    </Col>
                                                    <Col md={4} className='element'>
                                                        {toCurrencyUSD(Number(tr.payAmount))}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        ))}
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md={4}>
                                        </Col>
                                        <Col style={{ fontWeight: 'bold' }} className="element text-center mt-2" md={4}>
                                            Total amount:
                                        </Col>
                                        <Col style={{ fontWeight: 'bold' }} className="element text-center mt-2" md={4}>
                                            ${balance}
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <ChoosePaymentMethod paymentsList={paymentsList} clientSecret={StripePaymentKey} loadingCB={onLoadingPayment} successCB={onSuccessPayment} failCB={onFailPayment} />
                                    </Row>
                                </>

                }

            </Modal.Body>
            <Modal.Footer>
                <Row style={{ width: '100%' }}>
                    <Col xs={6} className="text-left">
                        <Button variant="secondary" style={{ width: '100%' }} onClick={onCloseModal}>{languageManager.T('GEN_CLOSE')}</Button>
                    </Col>
                    <Col xs={6} className="text-right">
                        {!checkout &&
                            <Button variant="primary" style={{ width: '100%' }} onClick={onPay}>Pay</Button>
                        }
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}

const Billing = ({
    userProfile
}) => {
    const navigateManager = useNavigate();
    const [isLoading, setLoadingStatus] = useState(true);
    const [cardNum, setCardNum] = useState('');
    const [cardsModalVisibility, setCardsModalVisibility] = useState(false);
    const [paymentsModalVisibility, setPaymentsModalVisibility] = useState(false);
    const [invoicesHistory, setInvoicesHistory] = useState(false);
    const [newAmount, setNewAmount] = useState(0);
    const [transactions, setTransactions] = useState([]);
    const [paymentsList, setPaymentsList] = useState([]);
    const [creditAmount, setCreditAmount] = useState(0);
    const [dueAmount, setDueAmount] = useState(0);

    async function getPaymentMethod() {
        const pm2 = await BillingAPI.getPaymentMethod();
        const paymentMethod = pm2?.filter(a => a.status === 'Complete')
        setPaymentsList(paymentMethod)
    }

    async function init() {
        try {
            setLoadingStatus(true);
            const state = store.getState();
            let CustomerCode = state.userProfile.entity.customerCode;
            let invoices = await BillingAPI.getBilling();
            let balance = await BillingAPI.getBalance(CustomerCode);

            if (balance)
            {
                setCreditAmount(balance['CMBalance'] + balance['RetainerBalance']);
                setDueAmount(balance['InvoiceBalance']);
            }            
            invoices.invoices?.sort(function (a, b) { return Number(b.BalanceDue) - Number(a.BalanceDue) });
            invoices.invoices.forEach((inv) => {
                if (inv.TermsCode === 'CC' || inv.TermsCode === 'DUR' || inv.TermsCode === 'NET30') {
                    inv.selected = true
                }
            });
            setTransactions(invoices.invoices);
            setLoadingStatus(false);
        } catch (error) {
            setLoadingStatus(false);
        }
    }

    useEffect(() => {
        init();
    }, []);

    function onClickSelectT(id) {
        for (let index = 0; index < transactions.length; index++) {
            if (transactions[index].BalanceDue === 0) {
                // continue
            }
            if (transactions[index].ID === id) {
                if (!transactions[index].selected) {
                    transactions[index].selected = true;
                } else {
                    transactions[index].selected = false;
                }
            }
        }
        setTransactions([...transactions]);        
    }

    function onClickOpenHistory(id) {
        for (let index = 0; index < transactions.length; index++) {
            if (transactions[index].ID === id) {
                if (!transactions[index].opened) {
                    transactions[index].opened = true;
                } else {
                    transactions[index].opened = false;
                }
            }
        }
        setTransactions([...transactions]);
    }

    const balance = transactions?.reduce((balance, elm) => {
        return balance + Number(elm.BalanceDue);
    }, 0);

    const remainingDue = transactions?.reduce((balance, invoice) => {
        const paymentsMade = invoice.Transactions?.reduce((paymentsMade, elm) => {
            var AmountPaid = 0;
            for (var payment in elm)
            {
                if (payment.status == "SUCCESS")
                {
                    AmountPaid += payment.amount;
                }
            }
            return paymentsMade + (AmountPaid);
        }, 0);
        return balance - Number(invoice.BalanceDue - paymentsMade);
    }, 0);

    const unpaidInvoices = transactions.filter((a) => a.BalanceDue > 0)
    return (
        <>
            {isLoading ? <Overlay show /> : null}
            <MainLayout pageTitle={T('SETTINGS_PAGE_SETTINGS_BILLING')}>
                <ModalCC getPaymentMethod={getPaymentMethod} userProfile={userProfile} paymentsList={paymentsList} cardsModalVisibility={cardsModalVisibility} setCardsModalVisibility={setCardsModalVisibility} />
                <ModalPayment paymentsList={paymentsList} reload={init} paymentsModalVisibility={paymentsModalVisibility} setPaymentsModalVisibility={setPaymentsModalVisibility} invoices={unpaidInvoices} />
                <Container className="billing-page">

                    <Row className='mt-4'>                                               
                        <Col style={{ 'border': 'red solid 0px' }}>                               
                            <Card style={{ height: '100%' }}>
                                <div className='balance-warning'>Used credits are reflected on the following business day</div>  
                                <Card.Body className="text-center">
                                    <div className="total-balance">
                                        <div className="h4">{T('SETTINGS_BILLG_LABEL_RETAINER')}</div>
                                        <div className="h2">{toCurrencyUSD(null || creditAmount)}</div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card>
                                <Card.Body className="text-center">
                                    <p>
                                        {T('SETTINGS_BILLG_LABEL_PAY_BALANCE_TITLE')}&nbsp;
                                        <OverlayTrigger style="mx-7 flex-shrink-1"
                                            placement="bottom"
                                            overlay={<Tooltip id="pay-balance-tooltip">{T('SETTINGS_BILLG_LABEL_PAY_BALANCE_TOOLTIP')}</Tooltip>}
                                        >
                                            <span style={{ cursor: 'pointer' }}>
                                                <InformationCircleOutline width="24px" height="24px" />
                                            </span>
                                        </OverlayTrigger>
                                        <br />
                                        <span className="h2">{toCurrencyUSD(dueAmount || 0)}</span>
                                    </p>
                                    <Button onClick={() => setPaymentsModalVisibility(true)} variant="primary" className="w-100">{T('BILLING_PAY_NOW')}</Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col xs={{ order: 'last' }} md={{ order: 'first' }}>
                            <Button className='invoice-history-button' onClick={() => setInvoicesHistory(!invoicesHistory)}>
                                <input readOnly checked={invoicesHistory} type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                                <span style={{ marginLeft: '5px' }}>Invoices history</span>
                            </Button>
                        </Col>
                        <Col className="text-right" md={6}>
                            <Button className='new-credit-card-button' onClick={() => setCardsModalVisibility(true)}>
                                <CardOutline
                                    className="ccard-card-icon"
                                    height="35px"
                                    width="35px"
                                />
                                {"Your credit cards"}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={12}>
                            <TransactionTable onClickOpenHistory={onClickOpenHistory} onClickSelectT={onClickSelectT} invoices={invoicesHistory ? transactions : unpaidInvoices} />
                        </Col>
                    </Row>
                </Container>
            </MainLayout>
        </>
    );
}


const mapStateToProps = (appState) => ({
    userProfile: appState.userProfile
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Billing);